module.exports = __webpack_public_path__ + "assets/img/b0b8472fb97a2dcdf63b315f78379b27.svg";